/** Worked examples for setup's placeholders: one is picked per page load and used
 *  for the textarea, the card's label and the card's question together, so they read
 *  as one example (rough description → label → sharpened question). Spans fields so
 *  setup doesn't read as psych/medicine-only. */
export interface SetupExample { description: string; label: string; question: string }

export const EXAMPLES: SetupExample[] = [
  {
    description: "How screens at bedtime affect teenagers' sleep, and whether it matters what they're doing on them",
    label: "Bedtime screens & teen sleep",
    question: "Does evening screen use (social media, gaming, video) change sleep onset or duration in 12–18-year-olds?",
  },
  {
    description: "What colonial administrators' archives leave out about local resistance",
    label: "Silences in colonial archives",
    question: "How do British colonial records in East Africa (1890–1960) omit or reframe local resistance, and how have historians read against them?",
  },
  {
    description: "Why lithium batteries wear out faster when they're charged fast",
    label: "Fast charging & battery wear",
    question: "How does fast charging affect capacity fade in lithium-ion cells, and which mechanisms (lithium plating, SEI growth) dominate?",
  },
  {
    description: "Whether raising the minimum wage costs jobs",
    label: "Minimum wage & employment",
    question: "Do minimum wage increases reduce employment among low-wage workers, and does the effect differ by region or industry?",
  },
];

export function pickExample(rand: () => number = Math.random): SetupExample {
  return EXAMPLES[Math.min(EXAMPLES.length - 1, Math.floor(rand() * EXAMPLES.length))];
}

export const eg = (s: string) => `e.g. ${s}`;
